Ext.define('SA.VectorMapTileSourceUrls', {
    singleton: true,

    get(data) {
        var members = encodeURIComponent(JSON.stringify(data).replace(/^\{|\}$/g, '')),
            placeholders = ['x', 'y', 'z'].map(component => encodeURIComponent('"') + component + encodeURIComponent('":') + `{${component}}`),
            v = encodeURIComponent('get'),
            r = encodeURIComponent('data/map/tile'),
            d = encodeURIComponent('{') + [...placeholders, members].join(encodeURIComponent(',')) + encodeURIComponent('}'),
            f = encodeURIComponent('application/vnd.mapbox-vector-tile');

        return `${location.protocol}//${location.host}/dispatch.php?v=${v}&r=${r}&d=${d}&f=${f}`;
    }
});